import React, { useCallback, useState } from "react";

import { WorkspaceRoutinesStackScreenProps } from "../WorkspaceRoutinesNavigation";
import { HeaderButton } from "@/src/components/mobile/Button/HeaderButtons";
import { useIntl } from "react-intl";

import { WorkspaceRoutineOccasionTab } from "./WorkspaceRoutineOccasionNavigation";
import { WorkspaceRoutineOccasionStatusTabScreen } from "./WorkspaceRoutineOccasionStatusTabScreen";

import { OrgButton } from "../../OrgButton";
import { useWorkspaceId } from "../../workspaceId";
import { WorkspaceRoutineOccasionAnalyticsTabScreen } from "./WorkspaceRoutineAnalytics";
import { WorkspaceRoutineStatusOverviewTabScreen } from "./WorkspaceRoutineStatusOverview";

export function WorkspaceRoutinesOccasionScreen(
  props: WorkspaceRoutinesStackScreenProps<"WorkspaceRoutineOccasion">
) {
  const navigateDeprecated = props.navigation.navigate;
  const onBackPress = useCallback(() => {
    if (props.route.params.archived) {
      navigateDeprecated("WorkspaceArchivedRoutines", {});
    } else {
      navigateDeprecated("WorkspaceComplianceRoutines" as any, {});
    }
  }, [navigateDeprecated, props.route.params.archived]);

  const intl = useIntl();

  const statusTitle = intl.formatMessage({
    defaultMessage: "Status",
    description: "WorkspaceRoutineOccasionScreen tab title for status view",
  });
  const analyticsTitle = intl.formatMessage({
    defaultMessage: "Analytics (Preview)",
    description: "WorkspaceRoutineOccasionScreen tab title for analytics view",
  });
  const statusOverviewTitle = intl.formatMessage({
    defaultMessage: "Status Overview (Preview)",
    description:
      "WorkspaceRoutineOccasionScreen tab title for status overview view",
  });

  const workspaceId = useWorkspaceId();

  const [hasAdmin, setHasAdmin] = useState(false);

  return (
    <WorkspaceRoutineOccasionTab.Navigator
      title=""
      headerLeft={() => <HeaderButton type="WEB-BACK" onPress={onBackPress} />}
      headerRight={() =>
        hasAdmin ? (
          <OrgButton
            title="Admin"
            backgroundColor="primary"
            tintColor="text-inverted"
            onPress={() => {
              props.navigation.navigate("RoutineEdit", {
                id: props.route.params.routineId,
                orgWorkspaceId: workspaceId,
              });
            }}
          />
        ) : null
      }
    >
      <WorkspaceRoutineOccasionTab.Screen
        name="WorkspaceRoutineOccasionStatus"
        options={{
          headerShown: false,
          title: statusTitle,
        }}
      >
        {() => (
          <WorkspaceRoutineOccasionStatusTabScreen
            routineId={props.route.params.routineId}
            sequenceNumber={props.route.params.sequenceNumber}
            setHasAdmin={setHasAdmin}
            setSequenceNumber={(sequenceNumber) => {
              props.navigation.setParams({ sequenceNumber });
            }}
            onPressListItem={(
              routineId,
              storeId,
              storeName,
              storeTimezone,
              sequenceNumber
            ) => {
              props.navigation.navigateDeprecated("RoutineOccasion", {
                routineId,
                sequenceNumber,
                storeId,
                storeName,
                storeTimezone,
              });
            }}
          />
        )}
      </WorkspaceRoutineOccasionTab.Screen>

      <>
        <WorkspaceRoutineOccasionTab.Screen
          name="WorkspaceRoutineOccasionAnalytics"
          options={{
            headerShown: false,
            title: analyticsTitle,
          }}
        >
          {() => (
            <WorkspaceRoutineOccasionAnalyticsTabScreen
              routineId={props.route.params.routineId}
            />
          )}
        </WorkspaceRoutineOccasionTab.Screen>
        <WorkspaceRoutineOccasionTab.Screen
          name="WorkspaceRoutineOccasionStatusOverview"
          options={{
            headerShown: false,
            title: statusOverviewTitle,
          }}
        >
          {() => (
            <WorkspaceRoutineStatusOverviewTabScreen
              routineWorkspaceId={props.route.params.routineId}
            />
          )}
        </WorkspaceRoutineOccasionTab.Screen>
      </>
    </WorkspaceRoutineOccasionTab.Navigator>
  );
}
